if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.js-announcement-slider');
      this.slides = this.querySelectorAll('.js-slide');
      this.detailBtns = document.querySelectorAll('.js-announcement-details');
      this.aggregateModal = document.querySelector('#announcement-modal-aggregate');
    }

    connectedCallback() {
      document.body.style.setProperty(`--announcement-bar-height`, `${this.clientHeight}px`);

      if (this.aggregateModal) {
        // Prevent visible icon shift due to announcement bar height changing
        this.querySelector('.announcement-modal-aggregate__opener')?.classList.remove('hidden');
      }

      this.detailBtns.forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          const connectedOpener = button.dataset.detailsModal;
          if (connectedOpener) {
            const modalOpener = this.querySelector(`modal-opener[data-modal='${connectedOpener}'] button`);
            if (modalOpener) {
              // Close aggregate modal
              if (this.aggregateModal?.hasAttribute('open')) {
                this.aggregateModal.hide();
              }

              // Open connected modal
              modalOpener.click();

              // Make matching announcement the active slide
              if (flickitySlider) {
                const currentSlide = modalOpener.closest('.announcement-bar__slide');
                const currentSlideIndex = currentSlide?.dataset.slideIndex;
                if (currentSlideIndex) {
                  flickitySlider.selectCell(parseInt(currentSlideIndex));
                  flickitySlider.playPlayer();
                }
              }
            }
          }
        });
      });

      if(!Flickity || this.slides.length <= 1) return;

      let showArrows = true;
      if (this.aggregateModal) {
        // Don't show arrows when aggregate modal present
        showArrows = false;
      }

      this.slides.forEach(slide => slide.classList.remove('hidden-slide'));

      const flickitySlider = new Flickity(this.slider, {
        autoPlay: Number(this.slider.getAttribute('data-js-slide-delay')),
        adaptiveHeight: true,
        pageDots: false,
        prevNextButtons: showArrows,
        percentPosition: false,
        pauseOnHover: true,
        wrapAround: true,
      });

      flickitySlider.on('change', () => {
        const viewport = this.querySelector('.flickity-viewport');
        const selected = this.querySelector('.flickity-viewport .is-selected');
        if (viewport.offsetHeight < selected.offsetHeight) {
          if(selected.clientHeight > 0) this.style.height = `${selected.clientHeight}px`;
          viewport.style.height = `${selected.clientHeight + 2}px`;
        }
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
